import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const IntroRevenue = () => {
  const { introRevenue, introRevenueChange } = useSelector((state) => state.marketing.totals);
  const currency = useSelector((state) => state.marketing.currencySymbol);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <MoneyDisplay value={introRevenue} currency={currency} disableAnimation={isUserQa} />
      <PercentChanged
        changeValue={introRevenueChange}
        currencySymbol={currency}
        toolTip="Percent change from previous month"
        showBorder
      />
    </>
  );
};

export default IntroRevenue;
